import { AppContext } from "context/AppContext";
import React, { useContext, createContext, useState } from "react";
import styles from "./ZamowieniaInfo.module.css"
import {DollarSign, Folder, FolderOpenDot, LampFloor, LayoutGrid, LucideLampFloor } from 'lucide-react';


// Mock AppContext do celów podglądu




// --- Sub-komponenty ---

const StatCard = ({ label, value, unit, variant = "blue", isError = false }) => {
  const cardClass = isError ? "orangeCard" : `${variant}Card`;
  const textClass = isError ? "orangeText" : `${variant}Text`;
  const subTextClass = isError ? "orangeSub" : `${variant}Sub`;

  return (
    <div className={`statCard ${cardClass}`}>
      <span className={`cardLabel ${subTextClass}`}>{label}</span>
      <div className="cardValueGroup">
        <span className={`cardValue ${textClass}`}>{value}</span>
        <span className={`cardUnit ${subTextClass}`}>{unit}</span>
        {/* {isError && <div className="badge">Braki</div>} */}
      </div>
    </div>
  );
};

const ProgressItem = ({ label, current, total, unit, color = "#2563eb" ,jednostka}) => {
  const percentage = Math.round((current / total) * 100) || 0;
  const isFinished = percentage >= 100;
  const fillColor = isFinished ? "#10b981" : color;
  const zostalo = total - current

  if(total>0){
      return (
    <div className="progressItem">
      <div className="progressHeader">
        <span className="progressTitle">{label}</span>
        <span className="progressPercent" style={{ color: fillColor }}>
          {percentage}%
        </span>
      </div>
      <div className="progressBarContainer">
        <div 
          className="progressBarFill" 
          style={{ width: `${percentage}%`, backgroundColor: fillColor }}
        />
      </div>
      <div className="progressFooter">
        <span className="footerText">Zakończono: {current.toLocaleString()} {unit}</span>
        <span className="footerText">Całość: {total.toLocaleString()} {unit}</span>
      {zostalo > 0 && <span className="footerText">Zostało: <span className="footerTextYellow">{zostalo.toLocaleString()} </span>  {unit}</span>}  
      </div>
    </div>
  );
  }

};





// --- Główny Komponent ---

export default function ZamowieniaInfo() {
  const { showZamowieniaInfo, setShowZamowieniaInfo, zamowienia, zamowieniaInfo } = useContext(AppContext);

  if (!showZamowieniaInfo) return null;

  const selectedCount = zamowienia.filter(x => x.select).length;
  const techCount = zamowienia.filter(x => x.select && x.technologia_id).length;
  const hasTechError = techCount !== selectedCount;

const Policz22 = ({zamowieniaInfo}) => {



 console.table(zamowieniaInfo)

let przeloty_druk	= zamowieniaInfo.przeloty_druk
let przeloty_falc	= zamowieniaInfo.przeloty_falc
let przeloty_druk_zakonczone	= zamowieniaInfo.przeloty_druk_zakonczone
let przeloty_falc_zakonczone	= zamowieniaInfo.przeloty_falc_zakonczone

let przeloty_druk_all	= zamowieniaInfo.przeloty_druk_all
let przeloty_druk_zostalo	= zamowieniaInfo.przeloty_druk_zostalo
let przeloty_falc_all	= zamowieniaInfo.przeloty_falc_all
let przeloty_falc_zostalo	= zamowieniaInfo.przeloty_falc_zostalo



   let procent_druk = (przeloty_druk_zakonczone * 100 ) / zamowieniaInfo.przeloty_druk_all
  //  let procent_druk = ((zamowieniaInfo.przeloty_druk_all - zamowieniaInfo.przeloty_druk_zostalo) / zamowieniaInfo.przeloty_druk_all) * 100 
   let zostalo_do_falcu = (przeloty_falc * (procent_druk / 100)) - (przeloty_falc_all-przeloty_falc_zostalo)

// console.log("procent: "+procent_druk)

   return Math.round(zostalo_do_falcu).toLocaleString()
}

const Policz = ({ zamowieniaInfo }) => {
  // 1. Bezpiecznie wyciągamy wartości i konwertujemy je na liczby
  const wydrukowano = Number(zamowieniaInfo.przeloty_druk_zakonczone) || 0;
  const pofalcowano = Number(zamowieniaInfo.przeloty_falc_zakonczone) || 0;

  // 2. Różnica to fizyczny bufor na hali
  const dostepnyFalc = wydrukowano - pofalcowano;

  // 3. Logujemy w konsoli przeglądarki, żebyś widział co dokładnie się liczy
  console.log("DEBUG POLICZ:", { wydrukowano, pofalcowano, dostepnyFalc });

  // 4. Zwracamy wynik zabezpieczony przed wartościami ujemnymi
  return Math.max(0, Math.round(dostepnyFalc)).toLocaleString();
};

  return (
    <div className="overlay">
      <style>{`
        .overlay {
          position: fixed;
          inset: 0;
          z-index: 50;
          display: flex;
          align-items: flex-start;
          justify-content: center;
          background-color: rgba(15, 23, 42, 0.5);
         // backdrop-filter: blur(4px);
          // padding-top: 3rem;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
        }
        .window {
          position: relative;
          width: 100%;
          height: 550px;
          max-width: 600px;
          background-color: #ffffff;
          border-radius: 1rem;
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
          border: 1px solid #e2e8f0;
          overflow: hidden;
          margin: 0 1rem;
        }
        .header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 1rem 1.5rem;
          border-bottom: 1px solid #f1f5f9;
        }
        .headerTitleGroup {
          display: flex;
          align-items: center;
          gap: 0.75rem;
        }
        .accentBar {
          width: 4px;
          height: 1.5rem;
          background-color: #2563eb;
          border-radius: 9999px;
        }
        .title {
          font-size: 1.125rem;
          font-weight: 700;
          color: #1e293b;
          margin: 0;
        }
        .closeButton {
          padding: 0.5rem;
          background: transparent;
          border: none;
          color: #94a3b8;
          cursor: pointer;
          border-radius: 9999px;
          display: flex;
          transition: background-color 0.2s;
        }
        .closeButton:hover {
          background-color: #f1f5f9;
        }
        .content {
          padding: 1.5rem;
        }
        .statsGrid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 1rem;
          margin-bottom: 1rem;
        }
        .statCard {
        display:flex;
        align-items: center;
          justify-content: space-between;

          padding: 0.5rem;
          border-radius: 0.75rem;
          border: 1px solid #f1f5f9;
        }
        .cardLabel {
          display: block;
          font-size: 0.7rem;
          font-weight: 700;
          text-transform: uppercase;
          margin-bottom: 0.25rem;
          letter-spacing: 0.025em;
        }
        .cardValueGroup {
          display: flex;
          align-items: baseline;
          gap: 0.25rem;
        }
        .cardValue {
          font-size: 1.275rem;
          font-weight: 900;
        }
        .cardUnit {
          font-size: 0.875rem;
          font-weight: 600;
        }
        .blueCard { background-color: #eff6ff; border-color: #dbeafe; }
        .blueText { color: #2563eb; }
        .blueSub { color: rgba(37, 99, 235, 0.7); }
        .greenCard { background-color: #f0fdf4; border-color: #dcfce7; }
        .greenText { color: #10b981; }
        .greenSub { color: rgba(16, 185, 129, 0.7); }
        .orangeCard { background-color: #fff7ed; border-color: #ffedd5; }
        .orangeText { color: #f97316; }
        .orangeSub { color: rgba(249, 115, 22, 0.7); }
        .badge {
          margin-left: auto;
          padding: 0.125rem 0.5rem;
          background-color: #fed7aa;
          color: #9a3412;
          font-size: 0.625rem;
          font-weight: 900;
          border-radius: 4px;
          text-transform: uppercase;
        }
        .sectionDivider {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          margin-bottom: 1.25rem;
          margin-top:1rem;
        }
        .dividerLabel {
          font-size: 0.65rem;
          font-weight: 900;
          color: #94a3b8;
          text-transform: uppercase;
          letter-spacing: 0.1em;

        }
        .line {
          height: 1px;
          background-color: #f1f5f9;
          flex: 1;
        }
        .progressItem { margin-bottom: 1.5rem; border-bottom: 1px solid #c4c4c4}

        //         .progressItem:hover {
        //   background-color: #f1f5f9;
        // }
        .progressHeader { display: flex; justify-content: space-between; margin-bottom: 0.5rem; align-items: flex-end; }
        .progressTitle { font-size: 0.875rem; font-weight: 700; color: #334155; }
        .progressPercent { font-size: 0.875rem; font-weight: 900; }
        .progressBarContainer { height: 0.625rem; background-color: #f1f5f9; border-radius: 9999px; overflow: hidden; }
        .progressBarFill { height: 100%; transition: width 0.7s ease-out; }
        .progressFooter { display: flex; justify-content: space-between; margin-top: 0.4rem; }
        .footerText { font-size: 0.8rem; color: #94a3b8; font-weight: 700; text-transform: uppercase; }
        .footerTextYellow { padding: 5px; font-size: 0.9rem; color: #f31409; font-weight: 700; text-transform: uppercase; }
        .summaryBox {
          margin-top: 2rem;
          background-color: #3a547c;
          border-radius: 0.75rem;
          padding: 1.25rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: #ffffff;
        }

                .summaryBoxKlejona {
          margin-top: 2rem;
          background-color: #1e3b30c4;
          border-radius: 0.75rem;
          padding: 0.5rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: #ffffff;
        }

                        .summaryBoxZeszyt {
          margin-top: 2rem;
          background-color: #ff9100;
          border-radius: 0.75rem;
          padding: 0.5rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: #ffffff;
        }

                                
        
        
        .summaryBoxWartosc {
          margin-top: 2rem;
          background-color: #423f3b;
          border-radius: 0.75rem;
          padding: 0.5rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: #ffffff;
        }

        .summaryLabel { color: #cbd5e1; font-weight: 500; }
        .summaryValue { font-size: 1.5rem; font-weight: 900; }
        .summaryValue2 { font-size: 1.2rem; font-weight: 900; }
      `}</style>

      <div className="window">
        <header className="header">
          <div className="headerTitleGroup">
            <div className="accentBar"></div>
            <h2 className="title">Suma zakończonych wykonań</h2>
          </div>
          <button 
            className="closeButton" 
            onClick={() => setShowZamowieniaInfo(false)}
          >
            <CloseIcon />
          </button>
        </header>

        <div className="content">
          <div className="statsGrid">
            <StatCard 
              label="Aktywne zamówienia" 
              value={selectedCount} 
              unit="szt." 
            />
            <StatCard 
              label="Przypisane technologie" 
              value={techCount} 
              unit={`/ ${selectedCount}`} 
              isError={hasTechError}
              variant="green"
            />
          </div>

          <div className="sectionDivider">
            <span className="dividerLabel">Suma wykonań</span>
            <div className="line"></div>
          </div>

          <ProgressItem 
            label="Druk"
            current={zamowieniaInfo.przeloty_druk_zakonczone}
            total={zamowieniaInfo.przeloty_druk}
            unit="ark."
          />

          <ProgressItem 
            label="Falcowanie"
            current={zamowieniaInfo.przeloty_falc_zakonczone}
            total={zamowieniaInfo.przeloty_falc}
            unit="ark."
            color="#6366f1"
          />





          <div className="summaryBoxKlejona">
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        
              <span className="summaryLabel">Zeszyt</span>
              <span className="summaryValue">{zamowieniaInfo.naklad_zeszyt.toLocaleString()}</span>
              <span style={{ marginLeft: '4px', color: '#94a3b8' }}>szt.</span>
            </div>
            
            <div>
              
              <span className="summaryLabel"> Kolbus </span>
              <span className="summaryValue">{zamowieniaInfo.naklad_klejona.toLocaleString()}</span>
              <span style={{ marginLeft: '4px', color: '#94a3b8' }}>szt.</span>
            </div>
            
                        {/* <div>
              
              <span className="summaryLabel"> Nakład </span>
              <span className="summaryValue">{zamowieniaInfo.naklad.toLocaleString()}</span>
              <span style={{ marginLeft: '4px', color: '#94a3b8' }}>szt.</span>
            </div> */}
            
          </div>




          {/* <p style={{ fontWeight:'bold'}}>Zamówienia progres</p> */}



          <div className="summaryBoxWartosc">
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <span className="summaryLabel">Wartość bez kosztów</span>
            </div>
            <div style={{ display:'flex',gap:'20px',margin: '15px 0px', color: '#ffffff' }}>
              <span className="summaryValue2">{zamowieniaInfo.wartosc_zamowienia_pl.toLocaleString()} PLN</span>
              <span className="summaryValue2">{zamowieniaInfo.wartosc_zamowienia_euro.toLocaleString()} EURO</span>
              <span className="summaryValue2">{zamowieniaInfo.wartosc_zamowienia_dolar.toLocaleString()} USD</span>
              <span style={{ marginLeft: '4px', color: '#94a3b8' }}></span>

            </div>
          </div>
        </div>
      </div>

      {/* -------------------------------------- */}

      <div className="window">
        <header className="header">
          <div className="headerTitleGroup">
            <div className="accentBar"></div>
            <h2 className="title">Suma realizacji - Zamówienia Progres</h2>
          </div>
          <button 
            className="closeButton" 
            onClick={() => setShowZamowieniaInfo(false)}
          >
            <CloseIcon />
          </button>
        </header>

        <div className="content">
          {/* <div className="statsGrid">

          </div> */}

          <ProgressItem 
            label="Druk progres"
            current={zamowieniaInfo.przeloty_druk_all - zamowieniaInfo.przeloty_druk_zostalo}
            total={zamowieniaInfo.przeloty_druk_all}
            unit="ark."
          />

          <ProgressItem 
            label="Falc progres"
            current={zamowieniaInfo.przeloty_falc_all - zamowieniaInfo.przeloty_falc_zostalo}
            total={zamowieniaInfo.przeloty_falc_all}
            unit="ark."
          />

          <ProgressItem 
            label="Zeszyt progres"
            current={zamowieniaInfo.przeloty_zeszyt_all - zamowieniaInfo.przeloty_zeszyt_zostalo}
            total={zamowieniaInfo.przeloty_zeszyt_all}
            unit="szt."
          />
                  <ProgressItem 
            label="PUR progres"
            current={zamowieniaInfo.przeloty_pur_all - zamowieniaInfo.przeloty_pur_zostalo}
            total={zamowieniaInfo.przeloty_pur_all}
            unit="szt."
          />
                  <ProgressItem 
            label="HotMelt progres"
            current={zamowieniaInfo.przeloty_hotmelt_all - zamowieniaInfo.przeloty_hotmelt_zostalo}
            total={zamowieniaInfo.przeloty_hotmelt_all}
            unit="szt."
          />

              <p className="progressTitle" style={{fontSize:'1.2rem'}}> Dostępny falc: {Policz({zamowieniaInfo})} ark. </p>

        </div>
      </div>

    </div>
  );
}

const CloseIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
);

const StackIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{color: '#60a5fa'}}><path d="M12 2L2 7l10 5 10-5-10-5z"></path><path d="M2 17l10 5 10-5"></path><path d="M2 12l10 5 10-5"></path></svg>
);

